<ng-template #processoCadastroTemplate>
  <div class="info-page">
    <h3>{{ actionLabel }} Cadastro</h3>
  </div>

  <form [formGroup]="form">
    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Nome<sup class="text-danger ms-2">*</sup></label>
        <input id="title" class="form-control" formControlName="title" placeholder="Nome do Processo" maxlength="300" />
        <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Texto de Apresentação</label>
        <textarea id="presentation" class="form-control" rows="5" formControlName="presentation" placeholder="Descrição da Apresentação" maxlength="3000"></textarea>
        <app-field-message [field]="fieldMessageRequired('presentation')" [erros]="fieldErros('presentation')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Data início do Processo</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br', showWeekNumbers: false  }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
        <app-field-message [field]="fieldMessageRequired('dt_start')" [erros]="fieldErros('dt_start')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Data máx. inscrição</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_subscription" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br', showWeekNumbers: false  }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
        <app-field-message [field]="fieldMessageRequired('dt_subscription')" [erros]="fieldErros('dt_subscription')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Data conclusão do Processo</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_conclusion" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br', showWeekNumbers: false  }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
        <app-field-message [field]="fieldMessageRequired('dt_conclusion')" [erros]="fieldErros('dt_conclusion')"></app-field-message>
      </div>
    </div>

    <label class="col-sm-12 pb-1">Órgão responsável</label>
    <div formArrayName="processagencytarget">
      <div class="form-group row m-b" *ngFor="let item of getFormArray('processagencytarget').controls; let i = index">
        <div class="col-10 col-md-8 col-xl-4">
          <ng-select 
            class="ng-select-alternative" 
            [items]="filters?.agencyList" 
            bindLabel="str_nome" 
            bindValue="num_codigo_pk" 
            placeholder="Selecione o Órgão" 
            [formControlName]="i">
          </ng-select>
        </div>
        <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="!isReadonly" (click)="removeField(i, 'processagencytarget')">
          <img src="assets/images/svgs/trash.svg" alt="Remover item"  tooltip="Remover item" placement="bottom">
        </button>
      </div>
    </div>
    <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="!isReadonly" (click)="addField('processagencytarget')">Novo Órgão</button>

    <label class="col-sm-12 pb-1">Analista</label>
    <div formArrayName="adjunct">
      <div class="form-group row m-b" *ngFor="let item of getFormArray('adjunct').controls; let i = index">
        <div class="col-10 col-md-8 col-xl-4">
          <ng-select class="ng-select-alternative" [items]="filters?.personList" bindLabel="label" bindValue="id" placeholder="Selecione o Analista" [formControlName]="i">
          </ng-select>
        </div>
        <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="!isReadonly" (click)="removeField(i, 'adjunct')">
          <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
        </button>
      </div>
    </div>
    <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="!isReadonly" (click)="addField('adjunct')">Novo Analista</button>

    <label class="col-sm-12 pb-1">Status</label>
    <div formArrayName="processprocessstat">
      <div class="form-group row m-b" *ngFor="let item of getFormArray('processprocessstat').controls; let i = index">
        <div class="col-10 col-md-8 col-xl-4">
          <ng-select class="ng-select-alternative" [items]="filters?.processprocessstatList" bindLabel="name" bindValue="id" placeholder="Selecione o Status" [formControlName]="i">
          </ng-select>
        </div>
        <button class="btn btn-danger col-1 btn-remove" type="button" *ngIf="!disabledBtn" (click)="removeField(i, 'processprocessstat')">
          <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
        </button>
      </div>
    </div>
    <button class="btn btn-success btn-add-item mb-4" type="button" *ngIf="!isReadonly" (click)="addField('processprocessstat')">Novo Status</button>

    <!-- Table -->
    <div class="form-group row m-b">
      <div class="col-12 col-sm-8">
        <label class="col-sm-12 pb-1">Questões:</label>
        <div class="system-table table-container system-table-m-b table-form">
          <div class="system-table-conteiner system-table-form-conteiner system-table-select">
            <table cdkDropList (cdkDropListDropped)="drop($event)" class="ordenacao">
              <thead>
                <tr>
                  <th class="width5">Ordem</th>
                  <th>Questão</th>
                  <th>Permite Branco</th>
                  <th class="text-center btn-icon-td">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of questionListTable; let i = index" cdkDrag>
                  <td class="title">
                    {{ i + 1 }}
                  </td>
                  <td>
                    {{item?.label}}
                  </td>
                  <td>
                    <ng-select class="ng-select-alternative" [items]="filters?.allowList" bindLabel="label" bindValue="id" [disabled]=" (item?.isDisabled)" [(ngModel)]="item.allow_null" [ngModelOptions]="{standalone: true}" placeholder="Selecione" [clearable]="false">
                    </ng-select>
                  </td>
                  <td>
                    <div class="btn-icon" *ngIf="!item?.isDisabled">
                      <span class="icon-table icon-red" (click)="removeQuestion(i)">
                        <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                      </span>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!questionListTable.length" class="border-b-radius">
                  <td colspan="4" class="text-center">Nenhuma Questão Cadastrada</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button class="btn btn-success btn-add-question mb-0" type="button" *ngIf="!isReadonly" (click)="openQuestionModal()">Nova Questão</button>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-white m-r-xs" *ngIf="entity?.id && entity?.can_clone" type="button" (click)="openCloneModal()">Clonar</button>
        <button class="btn btn-primary" *ngIf="!entity?.id" (click)="salvar()">Salvar</button>
        <button class="btn btn-primary" *ngIf="entity?.id && entity?.can_save" (click)="update()">Salvar</button>
      </div>
    </div>
  </form>

  <ng-template #modalQuestion>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Lista de questões</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeQuestionModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <div class="form-group row">
        <div class="col-sm-12 m-b">
          <label class="col-sm-12 pb-1">Questão</label>
          <ng-select id="report_type" class="ng-select-alternative" [items]="filters?.questionList" [(ngModel)]="question" [clearable]="false">
          </ng-select>
        </div>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeQuestionModal()">Fechar</button>
          <button class="btn btn-primary" type="button" [disabled]="!question" (click)="addQuestions()">Adicionar</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalClone>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Clonar processo</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <div class="form-group row">
        <div class="col-sm-12 m-b">
          <label class="col-sm-12 pb-1">Novo Nome</label>
          <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
        </div>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
          <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<div *ngIf="entity?.id, else novoProcesso">
  <ng-container *ngTemplateOutlet="processoCadastroTemplate"></ng-container>
</div>

<ng-template #novoProcesso>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-4">
      <h2>Processo</h2>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content box-content">
            <ng-container *ngTemplateOutlet="processoCadastroTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>